import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import withStyles from '@material-ui/core/styles/withStyles';

import SettingsIcon from '@material-ui/icons/Settings';
import DateRange from '@material-ui/icons/DateRange';
import Assessment from '@material-ui/icons/Assessment';
import Dashboard from '@material-ui/icons/Dashboard';
import CalendarToday from '@material-ui/icons/CalendarToday';
import InsertChart from '@material-ui/icons/InsertChart';
import Widgets from '@material-ui/icons/Widgets';
import StepConnector from '@material-ui/core/StepConnector';
import classNames from 'classnames';

export const DashboardConnector = withStyles({
  alternativeLabel: {
    top: 22
  },
  active: {
    '& $line': {
      backgroundImage: 'linear-gradient(to right top, #346c9f, #2e6292, #275885, #214e78, #1a456c)'
    }
  },
  completed: {
    '& $line': {
      backgroundImage: 'linear-gradient(to right top, #07a7d3, #1998c8, #2589bb, #2e7aad, #346c9f)'
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1
  }
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },

  active: {
    backgroundImage: 'linear-gradient(to right top, #346c9f, #2e6292, #275885, #214e78, #1a456c)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundImage: 'linear-gradient(to right top, #07a7d3, #1998c8, #2589bb, #2e7aad, #346c9f)'
  }
});

export function DashboardCreateStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed, icon } = props;

  const icons = {
    1: <Dashboard />,
    2: <Assessment />,
    3: <SettingsIcon />,
    4: <CalendarToday />
  };

  return (
    <div
      className={classNames(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {icons[String(icon)]}
    </div>
  );
}

DashboardCreateStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool.isRequired,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool.isRequired,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node.isRequired
};

export function DashboardUpdateStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed, icon } = props;

  const icons = {
    1: <Assessment />,
    2: <SettingsIcon />,
    3: <CalendarToday />
  };

  return (
    <div
      className={classNames(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {icons[String(icon)]}
    </div>
  );
}

DashboardUpdateStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool.isRequired,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool.isRequired,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node.isRequired
};

export const WidgetConnector = withStyles({
  alternativeLabel: {
    top: 22
  },
  active: {
    '& $line': {
      backgroundImage: 'linear-gradient(to right top, #346c9f, #2e6292, #275885, #214e78, #1a456c)'
    }
  },
  completed: {
    '& $line': {
      backgroundImage: 'linear-gradient(to right top, #07a7d3, #1998c8, #2589bb, #2e7aad, #346c9f)'
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1
  }
})(StepConnector);

const useWidgetIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },

  active: {
    backgroundImage: 'linear-gradient(to right top, #346c9f, #2e6292, #275885, #214e78, #1a456c)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundImage: 'linear-gradient(to right top, #07a7d3, #1998c8, #2589bb, #2e7aad, #346c9f)'
  }
});

export function WidgetStepIcon(props) {
  const classes = useWidgetIconStyles();
  const { active, completed, icon } = props;

  const icons = {
    1: <InsertChart />,
    2: <Widgets />,
    3: <DateRange />
  };

  return (
    <div
      className={classNames(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {icons[String(icon)]}
    </div>
  );
}

WidgetStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool.isRequired,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool.isRequired,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node.isRequired
};
